'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.errorHandler = void 0;
var tslib_1 = require('tslib');
var typed_redux_saga_1 = require('typed-redux-saga');
var prepareCall_1 = require('./prepareCall');
function errorHandler(gen, propagate) {
    if (propagate === void 0) {
        propagate = false;
    }
    return function catcher() {
        var _i, target, error_1;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    target = (0, prepareCall_1.prepareCall)(gen);
                    return [
                        5 /*yield**/,
                        (0, tslib_1.__values)((0, typed_redux_saga_1.apply)(target[0], target[1], args)),
                    ];
                case 1:
                    return [2 /*return*/, _a.sent()];
                case 2:
                    error_1 = _a.sent();
                    console.warn(error_1);
                    if (propagate) {
                        throw error_1;
                    }
                    return [3 /*break*/, 3];
                case 3:
                    return [2 /*return*/];
            }
        });
    };
}
exports.errorHandler = errorHandler;
